const utils = require('./utils');
const hooks = require('./hooks');

module.exports = Object.assign({}, utils, { hooks });



// WEBPACK FOOTER //
// ./node_modules/@feathersjs/commons/lib/index.js